<template>
  <div class="edu-banner-area banner03">
    <div class="container">
      <div class="row align-items-center">
        <div class="col-lg-6 col-md-12">
          <div class="edu-banner-content">
            <h1>Maritime Qualification Course Program</h1>
            <div class="edu-banner-btns">
              <a class="btn btn-lg btn-primary" href="/register">Register Now</a>
            </div>
          </div>
        </div>
        <div class="col-lg-6 col-md-12">
          <div class="edu-banner-image3">
            <img src="../../assets/img/logo/maritime-main-image.png" alt="banner-img" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MainBanner",
};
</script>
